module.exports = __webpack_public_path__ + "img/extras.db59ed9b.svg";